import React from 'react';
import { GridRow, GridCol } from '@naf/grid';
import * as S from './BenefitLayout.styles';

interface BenefitLayoutProps {
  left: React.ReactNode;
  right?: React.ReactNode;
}

export const BenefitLayout = ({ left, right }: BenefitLayoutProps) => (
  <S.StyledGrid>
    <GridRow>
      <GridCol s="12" m="12" l="8" xl="8">
        {left}
      </GridCol>
      <GridCol s="12" m="12" l="4" xl="4">
        {right}
      </GridCol>
    </GridRow>
  </S.StyledGrid>
);
